import { type FeatureModule } from '@store/features/types';

/**
 * Referrals feature module configuration
 * This is an API-only feature (no Redux slice needed)
 */
export const referralsFeature: FeatureModule = {
  id: 'referrals',
  name: 'Referrals',

  dependencies: [],

  reducers: {},

  middleware: [],

  // No persistence needed for this feature
  persistence: {
    enabled: false,
  },

  // No cross-tab sync needed
  sync: {
    enabled: false,
  },

  setup: _store => {
    // Feature initialization logic if needed
  },

  cleanup: _store => {
    // Feature cleanup logic if needed
  },
};
